/* ============================================
   SUNFEEL Premium Eyewear - Main JS
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
    initPageTransitionFix();
    initHeader();
    initMobileMenu();
    initScrollAnimations();
    initStaggerReveal();
    initTextReveal();
    initCounterAnimation();
    initCookieBanner();
    initFloatingButtons();
    initSmoothScroll();
    initParallax();
    initCursorGlow();
    initMagneticButtons();
    initTiltEffect();
    initLiquidGlassEffect();
    initImageLazyLoading();
    initQuantitySelectors();
    initAccordion();
    initTabs();
    initProductGallery();
    initLightbox();
    initCartFunctions();
    initProductFilters();
    initMobileGallerySwipe();
    initCountdown();
});

/* ============================================
   FIX PÁGINA PRETA AO VOLTAR
   O page-transition fica com classe .active no
   cache do browser. Este listener limpa ao restaurar.
   ============================================ */
function initPageTransitionFix() {
    const transition = document.querySelector('.page-transition');
    if (!transition) return;

    // Garante que o overlay nunca fique preso ativo (defensivo p/ bfcache no botão voltar/avançar).
    // NÃO interceptamos mais cliques: a navegação (inclusive paginação frente E trás) é nativa e
    // instantânea. O antigo interceptador atrasava todo link em 500ms com um wipe preto full-screen,
    // que na paginação era percebido como "página presa / não volta".
    var clearOverlay = function () {
        transition.classList.remove('active');
        transition.style.opacity = '';
        transition.style.pointerEvents = '';
    };
    window.addEventListener('pageshow', clearOverlay);
    clearOverlay();
}

/* ============================================
   STICKY HEADER
   ============================================ */
function initHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;
        header.classList.toggle('scrolled', currentScroll > 80);
        if (currentScroll > lastScroll && currentScroll > 300) {
            header.style.transform = 'translateY(-100%)';
        } else {
            header.style.transform = 'translateY(0)';
        }
        lastScroll = currentScroll;
    }, { passive: true });
}

/* ============================================
   MOBILE MENU
   ============================================ */
function initMobileMenu() {
    const toggle = document.querySelector('.mobile-toggle');
    const nav = document.querySelector('.main-nav');
    const closeBtn = document.querySelector('.mobile-nav-close');
    if (!toggle || !nav) return;

    function closeMenu() {
        nav.classList.remove('open');
        toggle.classList.remove('active');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        document.body.classList.remove('nav-open');
    }

    toggle.addEventListener('click', () => {
        const isOpen = nav.classList.toggle('open');
        toggle.classList.toggle('active', isOpen);
        toggle.setAttribute('aria-expanded', isOpen);
        document.body.style.overflow = isOpen ? 'hidden' : '';
        // nav-open eleva o header acima de tudo e anula seu transform
        // (senão o drawer, fixed dentro do header, colapsa/fica preso no z-index).
        document.body.classList.toggle('nav-open', isOpen);
    });

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    // Fecha ao tocar no fundo do painel (área vazia fora dos links)
    nav.addEventListener('click', function (e) { if (e.target === nav) closeMenu(); });

    nav.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', closeMenu);
    });

    // Fecha com ESC
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && nav.classList.contains('open')) closeMenu();
    });
}

/* ============================================
   SCROLL ANIMATIONS
   ============================================ */
function initScrollAnimations() {
    const elements = document.querySelectorAll('.animate-on-scroll');
    if (!elements.length) return;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    elements.forEach(el => observer.observe(el));
}

/* ============================================
   STAGGER REVEAL
   ============================================ */
function initStaggerReveal() {
    const grids = document.querySelectorAll('.products-grid, .values-grid, .collections-grid, .testimonials-grid, .features-grid, .about-values-grid');
    grids.forEach(grid => {
        const children = Array.from(grid.children);
        children.forEach((child, i) => {
            child.style.opacity = '0';
            child.style.transform = 'translateY(24px)';
            child.style.transition = `opacity 0.55s ease ${i * 0.08}s, transform 0.55s ease ${i * 0.08}s`;
        });
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    Array.from(entry.target.children).forEach(child => {
                        child.style.opacity = '1';
                        child.style.transform = 'translateY(0)';
                    });
                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: 0.08 });
        observer.observe(grid);
    });
}

/* ============================================
   TEXT REVEAL
   ============================================ */
function initTextReveal() {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.section-header h2').forEach(heading => {
        // Sem animação (reduced-motion ou sem IntersectionObserver): título fica visível normalmente.
        if (reduce || !('IntersectionObserver' in window)) return;
        heading.style.clipPath = 'inset(0 100% 0 0)';
        heading.style.transition = 'clip-path 0.9s cubic-bezier(0.77, 0, 0.175, 1)';
        const reveal = () => { heading.style.clipPath = 'inset(0 0 0 0)'; };
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) { reveal(); observer.unobserve(entry.target); }
            });
        }, { threshold: 0.15 });
        observer.observe(heading);
        // À prova de falha: se o observer não disparar (título ficaria clipado/invisível),
        // garante que o texto SEMPRE apareça — em qualquer tela.
        setTimeout(reveal, 2500);
    });
}

/* ============================================
   COUNTER ANIMATION
   ============================================ */
function initCounterAnimation() {
    const counters = document.querySelectorAll('[data-count]');
    if (!counters.length) return;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const target = parseInt(entry.target.dataset.count);
                const suffix = entry.target.dataset.suffix || '';
                let current = 0;
                const increment = target / 60;
                const timer = setInterval(() => {
                    current += increment;
                    if (current >= target) {
                        entry.target.textContent = target + suffix;
                        clearInterval(timer);
                    } else {
                        entry.target.textContent = Math.floor(current) + suffix;
                    }
                }, 16);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });
    counters.forEach(counter => observer.observe(counter));
}

/* ============================================
   COOKIE BANNER (LGPD)
   ============================================ */
function initCookieBanner() {
    const banner = document.querySelector('.cookie-banner');
    if (!banner) return;
    if (!localStorage.getItem('sunfeel_cookies')) {
        setTimeout(() => banner.classList.add('visible'), 2000);
    }
    banner.querySelectorAll('.cookie-accept, .cookie-reject').forEach(btn => {
        btn.addEventListener('click', () => {
            localStorage.setItem('sunfeel_cookies', btn.classList.contains('cookie-accept') ? 'all' : 'essential');
            banner.classList.remove('visible');
        });
    });
}

/* ============================================
   FLOATING BUTTONS
   ============================================ */
function initFloatingButtons() {
    const topBtn = document.querySelector('.float-btn-top');
    if (!topBtn) return;
    window.addEventListener('scroll', () => {
        topBtn.classList.toggle('visible', window.scrollY > 500);
    }, { passive: true });
    topBtn.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
}

/* ============================================
   SMOOTH SCROLL
   ============================================ */
function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    });
}

/* ============================================
   PARALLAX (apenas desktop)
   ============================================ */
function initParallax() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const elements = document.querySelectorAll('[data-parallax]');
    if (!elements.length) return;
    window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        elements.forEach(el => {
            const speed = parseFloat(el.dataset.parallax) || 0.5;
            el.style.transform = `translateY(${scrollY * speed}px)`;
        });
    }, { passive: true });
}

/* ============================================
   CURSOR GLOW (apenas desktop)
   ============================================ */
function initCursorGlow() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    const glow = document.createElement('div');
    glow.style.cssText = 'position:fixed;width:400px;height:400px;border-radius:50%;background:radial-gradient(circle,rgba(212,175,55,0.06) 0%,transparent 70%);pointer-events:none;z-index:1;transform:translate(-50%,-50%);transition:opacity 0.3s;opacity:0;';
    document.body.appendChild(glow);
    document.addEventListener('mousemove', (e) => {
        glow.style.left = e.clientX + 'px';
        glow.style.top = e.clientY + 'px';
        glow.style.opacity = '1';
    });
    document.addEventListener('mouseleave', () => { glow.style.opacity = '0'; });
}

/* ============================================
   MAGNETIC BUTTONS (apenas desktop)
   ============================================ */
function initMagneticButtons() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    document.querySelectorAll('.btn-gold, .btn-outline').forEach(btn => {
        btn.addEventListener('mousemove', (e) => {
            const rect = btn.getBoundingClientRect();
            const x = e.clientX - rect.left - rect.width / 2;
            const y = e.clientY - rect.top - rect.height / 2;
            btn.style.transform = `translate(${x * 0.12}px, ${y * 0.12}px)`;
        });
        btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
}

/* ============================================
   TILT 3D (apenas desktop)
   ============================================ */
function initTiltEffect() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    document.querySelectorAll('.glass-card, .product-card, .collection-card').forEach(card => {
        card.addEventListener('mousemove', (e) => {
            const rect = card.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            const rx = (y - rect.height / 2) / rect.height * -5;
            const ry = (x - rect.width / 2) / rect.width * 5;
            card.style.transform = `perspective(1000px) rotateX(${rx}deg) rotateY(${ry}deg) translateY(-6px)`;
        });
        card.addEventListener('mouseleave', () => { card.style.transform = ''; });
    });
}

/* ============================================
   LIQUID GLASS (apenas desktop)
   ============================================ */
function initLiquidGlassEffect() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    document.querySelectorAll('.glass-card').forEach(card => {
        card.addEventListener('mousemove', (e) => {
            const rect = card.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            card.style.background = `radial-gradient(circle at ${x}% ${y}%, rgba(212,175,55,0.1), rgba(255,255,255,0.6))`;
        });
        card.addEventListener('mouseleave', () => { card.style.background = ''; });
    });
}

/* ============================================
   LAZY LOADING
   ============================================ */
function initImageLazyLoading() {
    const images = document.querySelectorAll('img[data-src]');
    if (!images.length) return;
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
                img.classList.add('loaded');
                observer.unobserve(img);
            }
        });
    }, { rootMargin: '100px' });
    images.forEach(img => observer.observe(img));
}

/* ============================================
   QUANTITY SELECTORS
   ============================================ */
function initQuantitySelectors() {
    document.querySelectorAll('.qty-control').forEach(control => {
        const minus = control.querySelector('.qty-minus');
        const plus = control.querySelector('.qty-plus');
        const input = control.querySelector('.qty-input');
        if (!input) return;
        if (minus) {
            minus.addEventListener('click', () => {
                const val = parseInt(input.value) || 1;
                if (val > 1) { input.value = val - 1; input.dispatchEvent(new Event('change')); }
            });
        }
        if (plus) {
            plus.addEventListener('click', () => {
                input.value = (parseInt(input.value) || 1) + 1;
                input.dispatchEvent(new Event('change'));
            });
        }
    });
}

/* ============================================
   ACCORDION (FAQ)
   ============================================ */
function initAccordion() {
    document.querySelectorAll('.accordion-header').forEach(header => {
        header.addEventListener('click', () => {
            const item = header.parentElement;
            const content = item.querySelector('.accordion-content');
            const isActive = item.classList.contains('active');
            document.querySelectorAll('.accordion-item.active').forEach(active => {
                active.classList.remove('active');
                active.querySelector('.accordion-content').style.maxHeight = '0';
            });
            if (!isActive) {
                item.classList.add('active');
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });
}

/* ============================================
   TABS
   ============================================ */
function initTabs() {
    document.querySelectorAll('.tab-button').forEach(button => {
        button.addEventListener('click', () => {
            const group = button.closest('.tabs-container') || button.closest('section') || document;
            const target = button.dataset.tab;
            group.querySelectorAll('.tab-button').forEach(b => b.classList.remove('active'));
            group.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
            button.classList.add('active');
            const content = group.querySelector(`[data-tab-content="${target}"]`) || document.getElementById(target);
            if (content) content.classList.add('active');
        });
    });
}

/* ============================================
   PRODUCT GALLERY (miniaturas → imagem principal)
   ============================================ */
function initProductGallery() {
    const mainImage = document.getElementById('main-product-image');
    const thumbs = document.querySelectorAll('.thumb-image');
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
            thumbs.forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');

            // Fade suave
            mainImage.style.opacity = '0';
            setTimeout(() => {
                mainImage.src = thumb.dataset.full || thumb.src;
                if (thumb.dataset.srcset) mainImage.srcset = thumb.dataset.srcset;
                mainImage.style.opacity = '1';
            }, 150);
        });
    });

    // Cursor de zoom na imagem principal
    mainImage.style.cursor = 'zoom-in';
}

/* ============================================
   LIGHTBOX COM ZOOM E SWIPE
   ============================================ */
function initLightbox() {
    // Cria o overlay do lightbox
    const lb = document.createElement('div');
    lb.id = 'sunfeel-lightbox';
    lb.innerHTML = `
        <div class="lb-overlay"></div>
        <div class="lb-container">
            <button class="lb-close" aria-label="Fechar">&times;</button>
            <button class="lb-prev" aria-label="Anterior">&#8249;</button>
            <button class="lb-next" aria-label="Próximo">&#8250;</button>
            <div class="lb-img-wrap">
                <img class="lb-img" src="" alt="">
                <div class="lb-zoom-hint">Clique para dar zoom · Arraste para mover</div>
            </div>
            <div class="lb-thumbs"></div>
            <div class="lb-counter"></div>
        </div>
    `;
    document.body.appendChild(lb);

    const lbEl = document.getElementById('sunfeel-lightbox');
    const lbImg = lbEl.querySelector('.lb-img');
    const lbPrev = lbEl.querySelector('.lb-prev');
    const lbNext = lbEl.querySelector('.lb-next');
    const lbClose = lbEl.querySelector('.lb-close');
    const lbOverlay = lbEl.querySelector('.lb-overlay');
    const lbThumbsEl = lbEl.querySelector('.lb-thumbs');
    const lbCounter = lbEl.querySelector('.lb-counter');
    const lbHint = lbEl.querySelector('.lb-zoom-hint');

    let images = [];
    let currentIndex = 0;
    let scale = 1;
    let posX = 0, posY = 0;
    let isDragging = false;
    let dragStartX = 0, dragStartY = 0;
    let lastPosX = 0, lastPosY = 0;

    // Coleta todas as imagens do produto
    function collectImages() {
        images = [];
        const thumbs = document.querySelectorAll('.thumb-image');
        if (thumbs.length) {
            thumbs.forEach(t => {
                images.push({
                    full: t.dataset.full || t.src,
                    srcset: t.dataset.srcset || '',
                    alt: t.alt
                });
            });
        } else {
            const mainImg = document.getElementById('main-product-image');
            if (mainImg) images.push({ full: mainImg.src, srcset: mainImg.srcset || '', alt: mainImg.alt });
        }
    }

    function openLightbox(index) {
        collectImages();
        if (!images.length) return;
        currentIndex = index;
        scale = 1;
        posX = 0; posY = 0;
        lbEl.classList.add('active');
        document.body.style.overflow = 'hidden';
        showImage(currentIndex);
        buildThumbs();
    }

    function closeLightbox() {
        lbEl.classList.remove('active');
        document.body.style.overflow = '';
        resetZoom();
    }

    function showImage(i) {
        const img = images[i];
        resetZoom();
        lbImg.style.opacity = '0';
        lbImg.src = img.full;
        if (img.srcset) lbImg.srcset = img.srcset;
        lbImg.alt = img.alt;
        lbImg.onload = () => { lbImg.style.opacity = '1'; };
        lbCounter.textContent = `${i + 1} / ${images.length}`;
        lbPrev.style.display = images.length > 1 ? '' : 'none';
        lbNext.style.display = images.length > 1 ? '' : 'none';
        lbThumbsEl.querySelectorAll('.lb-thumb').forEach((t, idx) => {
            t.classList.toggle('active', idx === i);
        });
    }

    function buildThumbs() {
        lbThumbsEl.innerHTML = '';
        if (images.length <= 1) return;
        images.forEach((img, i) => {
            const t = document.createElement('img');
            t.src = img.full;
            t.alt = img.alt;
            t.className = 'lb-thumb' + (i === currentIndex ? ' active' : '');
            t.addEventListener('click', () => { currentIndex = i; showImage(i); });
            lbThumbsEl.appendChild(t);
        });
    }

    function resetZoom() {
        scale = 1; posX = 0; posY = 0;
        applyTransform();
        lbImg.style.cursor = 'zoom-in';
        lbHint.style.opacity = '1';
    }

    function applyTransform() {
        lbImg.style.transform = `translate(${posX}px, ${posY}px) scale(${scale})`;
    }

    function clampPos() {
        if (scale <= 1) { posX = 0; posY = 0; return; }
        const maxX = (lbImg.naturalWidth * scale - lbImg.width) / 2;
        const maxY = (lbImg.naturalHeight * scale - lbImg.height) / 2;
        posX = Math.max(-maxX, Math.min(maxX, posX));
        posY = Math.max(-maxY, Math.min(maxY, posY));
    }

    // Click para zoom
    lbImg.addEventListener('click', (e) => {
        if (isDragging) return;
        if (scale === 1) {
            scale = 2.5;
            const rect = lbImg.getBoundingClientRect();
            posX = (rect.width / 2 - (e.clientX - rect.left)) * 1.5;
            posY = (rect.height / 2 - (e.clientY - rect.top)) * 1.5;
            clampPos();
            lbImg.style.cursor = 'zoom-out';
            lbHint.style.opacity = '0';
        } else {
            resetZoom();
        }
        applyTransform();
    });

    // Scroll para zoom (desktop)
    lbImg.addEventListener('wheel', (e) => {
        e.preventDefault();
        scale = Math.max(1, Math.min(5, scale - e.deltaY * 0.003));
        if (scale === 1) { posX = 0; posY = 0; lbImg.style.cursor = 'zoom-in'; lbHint.style.opacity = '1'; }
        else { lbImg.style.cursor = 'zoom-out'; lbHint.style.opacity = '0'; }
        clampPos();
        applyTransform();
    }, { passive: false });

    // Drag para mover (desktop)
    lbImg.addEventListener('mousedown', (e) => {
        if (scale <= 1) return;
        isDragging = false;
        dragStartX = e.clientX - posX;
        dragStartY = e.clientY - posY;
        lbImg.style.cursor = 'grabbing';
        const onMove = (e) => {
            isDragging = true;
            posX = e.clientX - dragStartX;
            posY = e.clientY - dragStartY;
            clampPos();
            applyTransform();
        };
        const onUp = () => {
            lbImg.style.cursor = 'zoom-out';
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
            setTimeout(() => { isDragging = false; }, 10);
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
    });

    // Touch: pinch zoom + swipe
    let touchStartX = 0, touchStartY = 0;
    let lastTouchDist = 0;
    let touchMoved = false;

    lbImg.addEventListener('touchstart', (e) => {
        touchMoved = false;
        if (e.touches.length === 2) {
            lastTouchDist = Math.hypot(
                e.touches[0].clientX - e.touches[1].clientX,
                e.touches[0].clientY - e.touches[1].clientY
            );
        } else {
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            lastPosX = posX;
            lastPosY = posY;
        }
    }, { passive: true });

    lbImg.addEventListener('touchmove', (e) => {
        touchMoved = true;
        if (e.touches.length === 2) {
            e.preventDefault();
            const dist = Math.hypot(
                e.touches[0].clientX - e.touches[1].clientX,
                e.touches[0].clientY - e.touches[1].clientY
            );
            scale = Math.max(1, Math.min(5, scale * (dist / lastTouchDist)));
            lastTouchDist = dist;
            if (scale > 1) lbHint.style.opacity = '0';
            clampPos();
            applyTransform();
        } else if (scale > 1) {
            e.preventDefault();
            posX = lastPosX + (e.touches[0].clientX - touchStartX);
            posY = lastPosY + (e.touches[0].clientY - touchStartY);
            clampPos();
            applyTransform();
        }
    }, { passive: false });

    // Swipe lateral (quando não estiver com zoom)
    lbEl.addEventListener('touchstart', (e) => {
        if (e.target === lbImg && scale > 1) return;
        touchStartX = e.touches[0].clientX;
    }, { passive: true });

    lbEl.addEventListener('touchend', (e) => {
        if (scale > 1 || images.length <= 1) return;
        const diff = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(diff) > 50) {
            if (diff < 0) { currentIndex = (currentIndex + 1) % images.length; }
            else { currentIndex = (currentIndex - 1 + images.length) % images.length; }
            showImage(currentIndex);
        }
    }, { passive: true });

    // Navegação
    lbNext.addEventListener('click', () => { currentIndex = (currentIndex + 1) % images.length; showImage(currentIndex); });
    lbPrev.addEventListener('click', () => { currentIndex = (currentIndex - 1 + images.length) % images.length; showImage(currentIndex); });
    lbClose.addEventListener('click', closeLightbox);
    lbOverlay.addEventListener('click', closeLightbox);

    document.addEventListener('keydown', (e) => {
        if (!lbEl.classList.contains('active')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowRight') { currentIndex = (currentIndex + 1) % images.length; showImage(currentIndex); }
        if (e.key === 'ArrowLeft') { currentIndex = (currentIndex - 1 + images.length) % images.length; showImage(currentIndex); }
    });

    // Abre ao clicar na imagem principal ou miniaturas
    const mainImg = document.getElementById('main-product-image');
    if (mainImg) {
        mainImg.style.cursor = 'zoom-in';
        mainImg.addEventListener('click', () => openLightbox(currentIndex));
    }

    document.querySelectorAll('.thumb-image').forEach((thumb, i) => {
        thumb.addEventListener('dblclick', () => openLightbox(i));
    });
}

/* ============================================
   SWIPE NA GALERIA MOBILE (sem lightbox)
   ============================================ */
function initMobileGallerySwipe() {
    const gallery = document.querySelector('.product-gallery-main');
    const thumbs = document.querySelectorAll('.thumb-image');
    if (!gallery || !thumbs.length) return;

    let startX = 0;
    let currentThumbIndex = 0;

    thumbs.forEach((t, i) => {
        if (t.classList.contains('active')) currentThumbIndex = i;
    });

    gallery.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
    }, { passive: true });

    gallery.addEventListener('touchend', (e) => {
        const diff = e.changedTouches[0].clientX - startX;
        if (Math.abs(diff) < 40) return;
        if (diff < 0 && currentThumbIndex < thumbs.length - 1) {
            currentThumbIndex++;
        } else if (diff > 0 && currentThumbIndex > 0) {
            currentThumbIndex--;
        }
        thumbs[currentThumbIndex].click();
    }, { passive: true });
}

/* ============================================
   CART FUNCTIONS
   ============================================ */
function initCartFunctions() {
    updateCartBadge();
    document.querySelectorAll('.cart-remove').forEach(btn => {
        btn.addEventListener('click', function() {
            const item = this.closest('.cart-item');
            if (item) {
                item.style.opacity = '0';
                item.style.transform = 'translateX(-100%)';
                setTimeout(() => item.remove(), 300);
            }
        });
    });
}

function updateCartBadge() {
    const badges = document.querySelectorAll('.cart-count');
    if (!badges.length) return;
    // Contagem REAL do carrinho nativo do Shopify — nunca conta .cart-item da página
    // (que só existe no /cart). Assim o badge fica correto em TODAS as telas e o carrinho
    // não "parece vazio" ao navegar. Se o fetch falhar, mantém o valor server-rendered.
    fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { badges.forEach(function (b) { b.textContent = cart.item_count; }); })
        .catch(function () {});
}

/* ============================================
   COUNTDOWN (hero + barra fixa, alvo em data-countdown-target)
   ============================================ */
function initCountdown() {
    var source = document.querySelector('[data-countdown-target]');
    if (!source) return;
    var alvo = new Date(source.dataset.countdownTarget).getTime();
    if (isNaN(alvo)) return;

    function pad(n) { return String(n).padStart(2, '0'); }

    // Ao zerar: em vez de mostrar 00:00:00:00, a barra troca para o estado
    // "Coleção Palma · Já disponível" (via classe .is-launched no elemento da barra).
    function launched() {
        source.classList.add('is-launched');
    }

    function tick() {
        var d = alvo - Date.now();
        if (d <= 0) { launched(); return true; }
        var dias = Math.floor(d / 864e5); d %= 864e5;
        var h = Math.floor(d / 36e5); d %= 36e5;
        var m = Math.floor(d / 6e4); d %= 6e4;
        var s = Math.floor(d / 1e3);
        document.querySelectorAll('[data-cd="dias"]').forEach(function (el) { el.textContent = pad(dias); });
        document.querySelectorAll('[data-cd="horas"]').forEach(function (el) { el.textContent = pad(h); });
        document.querySelectorAll('[data-cd="min"]').forEach(function (el) { el.textContent = pad(m); });
        document.querySelectorAll('[data-cd="seg"]').forEach(function (el) { el.textContent = pad(s); });
        return false;
    }

    if (tick()) return; // já lançado: não inicia o intervalo
    var iv = setInterval(function () { if (tick()) clearInterval(iv); }, 1000);
}

/* ============================================
   PRODUCT FILTERS
   ============================================ */
function initProductFilters() {
    const filters = document.querySelectorAll('.filter-option input');
    if (!filters.length) return;
    filters.forEach(filter => {
        filter.addEventListener('change', () => {
            const activeFilters = {};
            document.querySelectorAll('.filter-option input:checked').forEach(checked => {
                const group = checked.name || checked.dataset.group;
                if (!activeFilters[group]) activeFilters[group] = [];
                activeFilters[group].push(checked.value);
            });
            document.querySelectorAll('.product-card[data-tags]').forEach(product => {
                const tags = product.dataset.tags ? product.dataset.tags.split(',') : [];
                let show = true;
                for (const group in activeFilters) {
                    if (activeFilters[group].length > 0 && !activeFilters[group].some(v => tags.includes(v))) {
                        show = false; break;
                    }
                }
                product.style.display = show ? '' : 'none';
            });
        });
    });
}
